import { RouteStack } from './../route-stack.model';
import * as RouteStackActions from './../actions/route-stack.action';
import {AppState, initializeState} from '../../app.state';
import {BalanceComponent} from '../../components/utilities/bank-utility/balance/balance.component';
import {UNHANDLED_ROUTE} from './../actions/route-stack.action';
import {CHANGE_WAITING_PAYMENT_STATUS, ChangeWaitingPaymentStatus} from '../actions/route-stack.action';

const initialState = initializeState();


export function reducer(state: AppState = initialState, action: RouteStackActions.Actions) {

  switch (action.type) {
    case RouteStackActions.ADD_Route:
      return ({
        ...state,
        RouteStack: state.RouteStack.concat(action.payload),
        unhandledRoute: false
      });
    case RouteStackActions.UNHANDLED_ROUTE:
      return ({
        ...state,
        RouteStack: state.RouteStack,
        unhandledRoute: true
      });
    case RouteStackActions.REMOVE_Route:
      state = { ...state,
        paymentData: state.paymentData,
        RouteStack: state.RouteStack.slice(0, state.RouteStack.length - 1),
        unhandledRoute: false};
      return state;
    case RouteStackActions.ADD_PAYMENT_OBJ:
      return ({
        ...state,
        RouteStack: state.RouteStack,
        paymentData: action.payload,
        unhandledRoute: false
      });
    case RouteStackActions.REMOVE_PAYMENT_OBJ:
      state = { ...state,
        paymentData: null,
        RouteStack: state.RouteStack,
        unhandledRoute: state.unhandledRoute};
      return state;
    case RouteStackActions.CHANGE_WAITING_PAYMENT_STATUS:
      return ({
        ...state,
        waitingPayment: action.payload,
        RouteStack: state.RouteStack,
        paymentData: state.paymentData,
        unhandledRoute: false
      });
    default:
      return state;
  }
}

